@if (isDenyAll) {
  <div class="alert alert-warning mb-0" role="alert" i18n="@@components.pdc_authentication_policy.deny_all">No sign-in method is enabled — logins are blocked.</div>
} @else {
  <p class="text-muted mb-2" i18n="@@components.pdc_authentication_policy.hint">Users can sign in using any of these methods:</p>
  <ul class="mb-0">
    @for (method of methods; track $index) {
      <li>
        {{ method.title }}
        @if (method.note) {
          <div class="text-muted small">{{ method.note }}</div>
        }
      </li>
    }
  </ul>
}

<p class="text-muted small mb-0 mt-2" i18n="@@components.pdc_authentication_policy.request_changes">Changes can be requested through support.</p>
